import React, {ReactNode, useContext, useState} from "react";
import {useMediaQuery, useTheme} from "@mui/material";

export interface DrawerState {
  drawerOpen: boolean,
  toggleDrawer: () => void
}

export const DrawerContext = React.createContext<DrawerState | undefined>(undefined);

export function useDrawer(): DrawerState {
  const drawerContext = useContext(DrawerContext);
  if (!drawerContext) {
    throw new Error('useDrawer must be used within the DrawerContext.Provider');
  }
  return drawerContext;
}

export function DrawerProvider(props: {
  children?: ReactNode;
}) {
  const theme = useTheme();
  const smallScreens = useMediaQuery(theme.breakpoints.down('md'));
  const [drawerState, setDrawerState] = useState(false);

  const toggleDrawer = () => {
    if(smallScreens) {
      setDrawerState(open => !open);
    }
  };

  return (
    <DrawerContext.Provider value={{drawerOpen: drawerState, toggleDrawer: toggleDrawer}}>
      {props.children}
    </DrawerContext.Provider>
  )
}
